import type { IProfile, ISettings, Nullable, QueueType } from '@/models'
import { GridModule } from '~/store/modules/grid'
import Vue from 'vue'
import Vuex from 'vuex'
import { Module, Mutation, State, createVuexStore, useStore as getStore } from 'vuex-simple'

Vue.use(Vuex)

export class MyStore {

    @State()
    offer = true

    @State()
    queue: Nullable<QueueType> = null

    @State()
    profile: Nullable<IProfile> = null

    @State()
    settings: Nullable<ISettings> = null

    @Module()
    agencies = new GridModule()

    @Module()
    auditEntries = new GridModule()

    @Module()
    regions = new GridModule()

    @Module()
    underwritingQuestions = new GridModule()

    @Module()
    modules = new GridModule()

    @Module()
    moduleGroups = new GridModule()

    @Module()
    underwritingQuestionAnswers = new GridModule()

    @Module()
    benefits = new GridModule()

    @Module()
    images = new GridModule()

    @Module()
    benefitCategories = new GridModule()

    @Module()
    underwritingRiskScores = new GridModule()

    @Module()
    medicalConditionGroups = new GridModule()

    @Module()
    accountManagers = new GridModule()

    @Module()
    healthcarePlans = new GridModule()

    @Module()
    healthcarePlansAdmin = new GridModule()

    @Module()
    hospitalLists = new GridModule()

    @Module()
    quoteRequests = new GridModule()

    @Module()
    quoteRequestsAdmin = new GridModule()

    @Module()
    underwritingTypes = new GridModule()

    @Module()
    insurers = new GridModule()

    @Module()
    insurerHospitalLists = new GridModule()

    @Module()
    insurerDiscounts = new GridModule()

    @Module()
    tenureDiscounts = new GridModule()

    @Module()
    memberMixDiscounts = new GridModule()

    @Module()
    midTermLoadings = new GridModule()

    @Module()
    minimumPremiums = new GridModule()

    @Module()
    discountTypes = new GridModule()

    @Module()
    excessAmounts = new GridModule()

    @Module()
    excessTypes = new GridModule()

    @Module()
    insurerModules = new GridModule()

    @Module()
    insurerModuleGroups = new GridModule()

    @Module()
    insurerExcessAmounts = new GridModule()

    @Module()
    queryTypes = new GridModule()

    @Module()
    postcodeAreas = new GridModule()

    @Module()
    bundles = new GridModule()

    @Module()
    bundlesAdmin = new GridModule()

    @Module()
    insurerSchemes = new GridModule()

    @Module()
    products = new GridModule()

    @Module()
    templates = new GridModule()

    @Module()
    contentPages = new GridModule()

    @Module()
    users = new GridModule()

    @Module()
    customerNeeds = new GridModule()

    @Module()
    notifications = new GridModule()

    @Module()
    indicativeBusinessQuotes = new GridModule()

    @Module()
    indicativeBusinessQuotesAdmin = new GridModule()

    @Module()
    factFindsBusiness = new GridModule()

    @Module()
    factFindsPersonal = new GridModule()

    @Module()
    factFindsAdminBusiness = new GridModule()

    @Module()
    factFindsAdminPersonal = new GridModule()

    @Module()
    mtjCases = new GridModule()

    @Module()
    mtjCasesAdmin = new GridModule()

    @Module()
    personalQuotes = new GridModule()

    @Module()
    personalQuotesAdmin = new GridModule()

    @Module()
    personalApplications = new GridModule()

    @Module()
    personalApplicationsAdmin = new GridModule()

    @Module()
    businessQuotes = new GridModule()

    @Module()
    businessQuotesProcessing = new GridModule()

    @Module()
    businessQuotesDiscounting = new GridModule()

    @Module()
    businessQuotesPricing = new GridModule()

    @Module()
    businessQuotesAdmin = new GridModule()

    @Module()
    businessApplications = new GridModule()

    @Module()
    businessApplicationsAdmin = new GridModule()

    @Module()
    processedBusinessApplications = new GridModule()

    @Mutation()
    mutateProfile(val: Nullable<IProfile>) {
        if (this.profile && val)
            Object.assign(this.profile, val)
        else
            this.profile = val
    }

    @Mutation()
    mutateSettings(val: Nullable<ISettings>) {
        if (this.settings && val)
            Object.assign(this.settings, val)
        else
            this.settings = val
    }

    @Mutation()
    mutateOffer(val: boolean) {
        this.offer = val
    }

    @Mutation()
    mutateQueue(val: Nullable<QueueType>) {
        this.queue = val
    }
}

const store = createVuexStore(new MyStore(), {
    strict: process.env.NODE_ENV !== 'production'
})

export const useStore = () =>
    getStore<MyStore>(store)

export default store